// Canonical authored English fallbacks for generic patient Journeys.
// These are *not* clinically approved by being here. English locale safety
// messages must remain source-current with the same fallback wording.
export const GENERIC_JOURNEY_COMPLETION = Object.freeze({
  compact: true,
  label: 'Journey summary',
  title: "You've reached the end of this guide",
  description: 'You do not need to open everything. Use the parts that are helpful to you and return whenever you need them.',
});

export const GENERIC_JOURNEY_GENERAL_DISCLAIMER =
  'This guide provides general information. It does not replace personalised clinical advice or instructions from your hospital. Always follow the instructions given to you by your own healthcare team.';

export const GENERIC_JOURNEY_DAY_SURGERY_DISCLAIMER =
  'This guide provides general information. It does not replace personalised clinical advice or instructions from your hospital. Always follow the fasting, medication and arrival instructions given to you by your own healthcare team.';
